import { DEFAULT_DOCUMENTS_TITLE, DEFAULT_PUBLISHER_BASE_URL } from '../constants/labels'
import type { AssetDocumentsProps, BackendDocumentSection, DocumentGroup } from './asset-documents-types'
import { buildPublisherUrl } from './publisher-url'

function parseDocumentSections(raw?: string): DocumentGroup[] {
  if (!raw) return []
  try {
    const parsed: BackendDocumentSection[] = JSON.parse(raw)
    if (!Array.isArray(parsed)) return []

    return parsed.map((section, idx) => ({
      id: `section-${idx}`,
      label: section.subSectionTitle ?? '',
      items: (section.documents ?? []).map(doc => ({
        label: doc.documentName ?? '',
        csParams: Array.isArray(doc.documentDataKeys) ? doc.documentDataKeys : [],
      })),
    }))
  } catch {
    return []
  }
}

export default function AssetDocuments(props: Readonly<AssetDocumentsProps>) {
  const sectionTitle = props.sectionTitle || DEFAULT_DOCUMENTS_TITLE
  const groups: DocumentGroup[] = parseDocumentSections(props.documentSections)
  const contentId = props.contentId

  return (
    <section className="cop-asset-details__documents">
      <h2 className="cop-asset-details__documents-title">{sectionTitle}</h2>

      {groups.map(group => (
        <div key={group.id} className="cop-asset-details__doc-group">
          <h3 className="cop-asset-details__doc-group-heading">{group.label}</h3>

          {group.items.map(item => {
            const url = buildPublisherUrl(DEFAULT_PUBLISHER_BASE_URL, contentId, item.csParams)

            return (
              <div key={item.label} className="cop-asset-details__doc-item">
                {url ? (
                  <a href={url} className="cop-asset-details__doc-link" target="_blank" rel="noopener noreferrer">
                    {item.label}
                  </a>
                ) : (
                  <span className="cop-asset-details__doc-link">{item.label}</span>
                )}
                <span className="cop-asset-details__doc-chevron" aria-hidden="true">
                  ›
                </span>
              </div>
            )
          })}
        </div>
      ))}
    </section>
  )
}
